import styled from 'styled-components';
import { DEVICES } from '@/theme';
import { Button, Tabs } from '@/ui';

export const StyledButton = styled(Button)`
  align-self: flex-end;
  &&&& {
    padding-inline: 3rem;
  }

  @media screen and ${DEVICES.TABLET_S} {
    align-self: flex-start;
  }
`;

export const StyledTabs = styled(Tabs)`
  align-items: flex-start;
  width: 100%;
  padding: 0;
  height: 100%;

  .ant-tabs-content-holder {
    padding: 0;
  }

  .ant-tabs-tabpane {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ant-tabs-content,
  .ant-tabs-content-holder {
    height: 100%;
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  gap: 1rem;
  min-height: 100%;
  flex-direction: column;

  @media screen and ${DEVICES.TABLET_S} {
    flex-direction: row;
  }
`;

export const StyledWrapper = styled.div`
  position: relative;
  min-height: 100%;
  padding: 0;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 2rem;
    padding-right: 0;
  }
`;
